import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 18.7 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18.7 10.3\" id=\"icon-chevron-down\">\r\n<path d=\"M0,1c0-0.3,0.1-0.5,0.3-0.7c0.4-0.4,1-0.4,1.4,0l7.6,7.6L17,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10,10\r\n\tc-0.4,0.4-1,0.4-1.4,0L0.3,1.7C0.1,1.5,0,1.3,0,1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol